
// SVG Icon: accordion-open
export default { id: "terriajs-accordion-open" };
export const id = "terriajs-accordion-open";
export const name = "accordion-open";
